import React, { useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { updateApplication } from '../../../actions/applications';
import { getRoute, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import ApplicationRecord from '../../../records/application';
import BeneficialOwnerCreate from './BeneficialOwnerCreate';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Error from '../../shared/Error';

export default function BeneficialOwner({location}) {
  const dispatch = useDispatch();

  const isLoading = useSelector(state => state.sessions.get('loading'));
  const application = useSessionEntity('application');
  const user = useSessionEntity('user');
  const company = useSessionEntity('company');
  const [addFormShown, setAddFormShown] = useState(false);

  useRouteStatus(location);

  const OwnerDetails = (props) => {
    return (<>
      <div className="card">
        <header className="card-header">
          <p className="card-header-title">
            Owner #{props.owner_number}
          </p>
          {props.owner_number > 1 ?
          <><span className="card-header-icon">
            <button
              className="delete is-small has-background-danger"
              data-email={props.owner_email}
              onClick={props.removeOwner}>
              Remove
            </button>
          </span> </> : null}
        </header>
        <div className="card-content">
          <p>{props.owner_name}</p>
          <p>{props.owner_email}</p>
        </div>
      </div>
    </>)
  };

  const save = e => {
    e.preventDefault();

    dispatch(loading(true));
    dispatch(asyncActions(
      updateApplication(new ApplicationRecord({...application.toJS(), are_additional_owners_confirmed: true})),
      getRoute()
    ))
    .then(res => dispatch(loading(false)));
  };

  const toggleAddOwner = () => setAddFormShown(!addFormShown);

  const persistOwners = (ownerList) => {
    dispatch(loading(true));
    dispatch(asyncActions(
      updateApplication(new ApplicationRecord({...application.toJS(), beneficial_owners: ownerList }))
    ))
    .then(() => addFormShown && toggleAddOwner())
    .then(() => dispatch(loading(false)));
  };

  const addOwner = values => {
    const temp = application.beneficial_owners.push(values);

    return persistOwners(temp);
  };

  const removeOwner = e => {
    const index = application.beneficial_owners.findIndex(b => b.get('email') === e.currentTarget.dataset.email);
    const temp = application.beneficial_owners.delete(index);

    return persistOwners(temp);
  };

  return (
    <div id="content">
      <div className="columns is-centered">
        <div className="column has-text-centered">
          <div className="is-size-4 has-text-weight-semibold">Are there any other owners of <span style={{ whiteSpace: 'nowrap' }}>{company.name}</span>?</div>
          <div className="has-text-weight-semibold text-green-highlight">Please add any individuals with 25% or more ownership</div>
        </div>
      </div>

      <Error />

			<div className="columns is-centered">
        <div className="column">
          {<OwnerDetails owner_number='1' owner_name={user.full_name} owner_email={user.get('email')} />}
        </div>
      </div>

      {application.beneficial_owners.map((b, idx) => {
        return (
          <div className="columns is-centered" key={idx + 2}>
            <div className="column">
              <OwnerDetails owner_number={idx + 2} owner_name={b.full_name} owner_email={b.get('email')} removeOwner={removeOwner} />
            </div>
          </div>)
      })}

      <div className="columns is-centered">
        <div className="column">
          <button role="add" className="button is-info is-outlined is-small" onClick={toggleAddOwner}>
            <span className="icon">
              <FontAwesomeIcon icon="plus" />
            </span>
            <span>Add another owner</span>
          </button>
        </div>
      </div>

      {addFormShown && <BeneficialOwnerCreate toggleAddOwner={toggleAddOwner} addOwner={addOwner} />}

      <div className="columns is-centered">
        <div className="column has-text-centered">
          <p className="mb-4">I herby certify, to the best of my knowledge, that the information provided
              above is complete and correct</p>
          <button
            onClick={save}
            type="submit"
            role="submit"
            disabled={isLoading}
            className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold', {
              'is-loading': isLoading
            })}>
            Next
          </button>
        </div>
      </div>
    </div>
  )
}
